import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upload-video-note',
  templateUrl: './upload-video-note.component.html',
  styleUrls: ['./upload-video-note.component.scss']
})
export class UploadVideoNoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
